/* eslint-disable no-dupe-keys */
import React from "react";
import { useState, useEffect } from "react";
import Axios from "axios";
import Form from "react-bootstrap/Form";
import bg from "../img/bg.png";
import "./PageLogin.css";

import { Link, useNavigate } from "react-router-dom";
import "../components/style.css";
import { FaArrowAltCircleLeft } from "react-icons/fa";

import No_image from "../img/No_Image.jpg";
import Swal from "sweetalert2";
import LoadingPage from "../components/LoadingPage";
import {
  checkGroupsUser,
  getlocalStorage,
  thai_date,
  maskIDNumber,
} from "../function/functionALL";
import Layout from "../components/Layout";

require("moment/locale/th");

const PageEditInformation = () => {
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_openRole = role?.openRole;
  const [imageUrl, setimageUrl] = useState([]);
  const navigate = useNavigate();
  const id = DataToken_.id;
  const [Datatest, setDatatest] = useState([]);
  const [loadingpage, setLoadingpage] = useState(true);

  const fetchUserData = async () => {
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_API_USERS}${id}/`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      );

      setDatatest(response.data);
      // const imageUrlHTTPS = response.data.image.replace(/^http:/, "https:");
      // setimageUrl(imageUrlHTTPS);
      if (response.data.image) {
        const imageUrlHTTPS = response.data.image.replace(/^http:/, "https:");
        setimageUrl(imageUrlHTTPS);
      } else {
        setimageUrl(null);
      }
      setLoadingpage(false);
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      } else {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "เรียกข้อมูลไม่สำเร็จ",
        });
      }
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [Datatest.air_worker]);

  const handleAbsent = (e) => {
    const updatedReason = e.target.value;

    Axios.patch(
      process.env.REACT_APP_API_USERS + `${id}/`,
      {
        air_worker: updatedReason,
      },
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ!",
        });
        fetchUserData();
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "แก้ไขข้อมูลไม่สำเร็จ",
        });
      });
  };

  return (
    <>
      {" "}
      <Layout>
        {loadingpage ? (
          <LoadingPage />
        ) : (
          <div>
            <Form>
              <div className="App login-box">
                <section
                  style={{
                    backgroundImage: `url(${bg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%",
                    backgroundSize: "cover",
                    minHeight: "1024px",
                  }}
                >
                  <div
                    className="mb-0 rounded"
                    style={{ padding: "68px 0 0 0" }}
                  >
                    <div className="row col-12 col-sm-12 ms-0 justify-content-center pt-3 ">
                      <div className="p-3 d-flex justify-content-center">
                        <div className="shadow-lg rounded col-sm-12 col-xs-12 col-lg-10 ">
                          <div className="card-body rounded">
                            <div className=" row d-flex p-2">
                              <div className=" col-3 col-xs-12 card-title text-center fs-5 w-100 fs-3 d-flex p-0 mt-2">
                                <div className="col-3 col-sm-3 text-start">
                                  <Link
                                    to={`/PageHome`}
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                      display: "inline-block",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-primary m-0 d-none d-md-block px-4 "
                                      style={{
                                        backgroundColor:
                                          "rgb(2, 117, 216,0.80)",
                                        border: "none",
                                      }}
                                    >
                                      ย้อนกลับ
                                    </button>
                                  </Link>
                                  <Link to={`/PageHome`} className="d-md-none">
                                    <FaArrowAltCircleLeft
                                      style={{
                                        fontSize: "22px",
                                        color: "#3399FF",
                                      }}
                                      className="mt-2"
                                    />
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-sm-12 text-center fw-bold mb-3"
                              style={{ fontSize: "21px", color: "#000000" }}
                            >
                              ข้อมูลส่วนตัว
                            </div>

                            <hr></hr>
                            <div className="row px-1 d-flex flex-row justify-content-center">
                              <div className="p-3 col-12 col-md-4 col-lg-4 text-center align-items-center">
                                <div className="mt-1">
                                  {/* {imagePreview ? (
                                                                <img src={imagePreview} alt="Profile" className="rounded img-fluid" style={{ maxHeight: "220px" }} />
                                                            ) : (
                                                                <img src={imageUrl || No_image} alt="Profile" className="rounded img-fluid" style={{ maxHeight: "220px" }} />
                                                            )}
                                                            <div className="mt-2 ">
                                                                <label htmlFor="imageInput" className="custom-file-upload btn btn-warning col-12 mt-1" >
                                                                    <input
                                                                        id="imageInput"
                                                                        type="file"
                                                                        accept="image/*"
                                                                        onChange={handleImageChange}
                                                                        style={{ display: 'none' }}
                                                                    />
                                                                    คลิกเพื่อเลือกไฟล์
                                                                </label>
                                                            </div>
                                                            <div className="mt-2 ">
                                                                {selectedImage && (
                                                                    <button className="btn btn-primary px-2 col-12" type="submit" onClick={handleFormSubmit}>
                                                                        คลิกเพื่ออัพโหลดรูปภาพ
                                                                    </button>
                                                                )}
                                                            </div> */}
                                  {imageUrl !== null ? (
                                    <img
                                      src={imageUrl}
                                      alt="Profile"
                                      className="rounded img-fluid"
                                      style={{ maxHeight: "220px" }}
                                    />
                                  ) : (
                                    <img
                                      src={No_image}
                                      alt="Profile"
                                      className="rounded img-fluid"
                                      style={{ maxHeight: "220px" }}
                                    />
                                  )}
                                </div>
                              </div>
                              <div className=" p-1 col-12 col-md-6 col-lg-6 mb-2 d-flex align-items-center">
                                <div
                                  className="tab-pane fade show active profile-overview w-100 d-flex justify-content-center align-items-center"
                                  id="profile-overview"
                                >
                                  <div
                                    className="col-12 col-sm-8 col-md-12 col-lg-12 "
                                    style={{
                                      fontSize: "14px",
                                      color: "#000000",
                                    }}
                                  >
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex ">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold ">
                                        เลขประจำตัวประชาชน :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {maskIDNumber(DataToken_.person_id)}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        ชื่อ :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {DataToken_.full_name}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        ตำแหน่ง :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {DataToken_.position}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12  col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        สังกัด :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {DataToken_.unit}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        ปฏิบัติหน้าที่ :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {DataToken_.work_unit}
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        ปีเกิด :{" "}
                                      </div>
                                      <div className="col-5 col-sm-5 col-md-5 col-lg-5 label">
                                        {thai_date(DataToken_.birthday, "year")}{" "}
                                      </div>
                                    </div>
                                    <hr />

                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold">
                                        เป็นผู้ปฏิบัติงาน :
                                      </div>
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 label">
                                        <input
                                          type="radio"
                                          name="reason"
                                          value="false"
                                          onChange={(e) => handleAbsent(e)}
                                          checked={
                                            Datatest.air_worker === false
                                          }
                                        />{" "}
                                        ภาคพื้น
                                      </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 ms-4 d-flex mt-1">
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 fw-bold"></div>
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 label">
                                        <input
                                          type="radio"
                                          name="reason"
                                          value="true"
                                          onChange={(e) => handleAbsent(e)}
                                          checked={Datatest.air_worker === true}
                                        />{" "}
                                        ภาคอากาศ
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </Form>
          </div>
        )}
      </Layout>
    </>
  );
};

export default PageEditInformation;
